import React from 'react';
import DashboardResellerComponent from './dashboard-reseller.component';

function DashboardReseller() {
    return <DashboardResellerComponent />;
}

export default DashboardReseller;
